import { matchPath } from 'react-router-dom';
import { LayoutConfig } from '../types/layout';

export const LAYOUT_CONFIGS = {
  MINIMAL: {
    showHeader: false,
    showAside: false,
    showFooter: false,
    showToolbar: false,
  },

  HEADER_ONLY: {
    showHeader: true,
    showAside: false,
    showFooter: false,
    showToolbar: false,
  },
  HEADER_FOOTER: {
    showHeader: true,
    showAside: false,
    showFooter: true,
    showToolbar: false,
    showExpFooter: true,
  },
  HEADER_FOOTER_ADMIN: {
    showHeader: true,
    showAside: true,
    showFooter: true,
    showToolbar: false,
    showExpFooter: false,
  },
  HEADER_FOOTER_: {
    showHeader: true,
    showAside: false,
    showFooter: true,
    showToolbar: false,
    showExpFooter: false,
  },
  FULL_DASHBOARD: {
    showHeader: true,
    showAside: true,
    showFooter: true,
    showToolbar: false,
  },
  PROFILE: {
    showHeader: true,
    showAside: true,
    showFooter: true,
    showToolbar: false,
    showExpFooter: false,
  },
  FOOTER: {
    showHeader: false,
    showAside: false,
    showFooter: true,
    showToolbar: false,
    showExpFooter: false,
  },
} as const;

const ROUTE_LAYOUT_MAP: Record<string, LayoutConfig> = {
  '/plans': LAYOUT_CONFIGS.MINIMAL,
  '/payment': LAYOUT_CONFIGS.MINIMAL,
  '/profile': LAYOUT_CONFIGS.MINIMAL,
  '/admin/overview': LAYOUT_CONFIGS.PROFILE,
  '/admin/overview/:section': LAYOUT_CONFIGS.PROFILE,
  '/biography/overview': LAYOUT_CONFIGS.PROFILE,
  '/expertise': LAYOUT_CONFIGS.PROFILE,
  '/recognition': LAYOUT_CONFIGS.PROFILE,
  '/team': LAYOUT_CONFIGS.PROFILE,
  '/team/admin': LAYOUT_CONFIGS.PROFILE,
  '/references': LAYOUT_CONFIGS.PROFILE,
  '/experiences': LAYOUT_CONFIGS.PROFILE,
  '/experiences/suggest': LAYOUT_CONFIGS.PROFILE,
  'payment/expert/success': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/waitinglist': LAYOUT_CONFIGS.PROFILE,
  '/my-experience': LAYOUT_CONFIGS.PROFILE,
  '/host-experience': LAYOUT_CONFIGS.PROFILE,
  '/my-experience/success': LAYOUT_CONFIGS.PROFILE,
  '/my-experience/draft': LAYOUT_CONFIGS.PROFILE,
  '/my-experience/paused': LAYOUT_CONFIGS.PROFILE,
  '/experience/admin': LAYOUT_CONFIGS.PROFILE,
  '/dashboard/admin': LAYOUT_CONFIGS.PROFILE,
  '/experience/edit/:id': LAYOUT_CONFIGS.PROFILE,
  '/experience/recreate/:id': LAYOUT_CONFIGS.FOOTER,
  '/experience/detail/:id': LAYOUT_CONFIGS.FOOTER,
  '/experience/booking/:id': LAYOUT_CONFIGS.FOOTER,
  '/experience/booking/:id/success': LAYOUT_CONFIGS.FOOTER,
  '/experience/draft': LAYOUT_CONFIGS.PROFILE,
  '/experience/guide': LAYOUT_CONFIGS.PROFILE,
  '/partner/my-experiences': LAYOUT_CONFIGS.PROFILE,
  '/my-introduction': LAYOUT_CONFIGS.PROFILE,
  '/introductions': LAYOUT_CONFIGS.PROFILE,
  '/introduction/request/:id': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/introduction/success': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/admin/introduction': LAYOUT_CONFIGS.PROFILE,
  '/biography': LAYOUT_CONFIGS.PROFILE,
  '/expert': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/dashboard': LAYOUT_CONFIGS.FULL_DASHBOARD,
  '/terms-conditions': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/privacy-policy': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/membership/payment': LAYOUT_CONFIGS.MINIMAL,
  '/main-dashboard': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/members-search': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/experiences-search': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/forums-search': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/circles-search': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/expert-search': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/search': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/member/overview': LAYOUT_CONFIGS.HEADER_FOOTER,
  '/experts/:partnerId': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/experts/:partnerId/book': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/expertise/checkout/:requestId': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/expertise/payment-success': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/manage-members': LAYOUT_CONFIGS.PROFILE,
  '/profile-member': LAYOUT_CONFIGS.PROFILE,
  '/manage-admins': LAYOUT_CONFIGS.PROFILE,
  '/manage-partners': LAYOUT_CONFIGS.PROFILE,
  // final user routes
  '/user/my-experience': LAYOUT_CONFIGS.PROFILE,
  '/user/:userId/my-team': LAYOUT_CONFIGS.PROFILE,
  '/user/:userId/my-team/add': LAYOUT_CONFIGS.PROFILE,
  '/user/:userId/my-team/edit/:id': LAYOUT_CONFIGS.PROFILE,
  '/user/refer': LAYOUT_CONFIGS.PROFILE,
  '/financial': LAYOUT_CONFIGS.PROFILE,
  '/financial/membership': LAYOUT_CONFIGS.PROFILE,
  '/membership/change': LAYOUT_CONFIGS.PROFILE,
  '/user/payment/method': LAYOUT_CONFIGS.PROFILE,
  '/help-center': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/help-center/:id': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/coming-soon': LAYOUT_CONFIGS.PROFILE,
  '/messages': LAYOUT_CONFIGS.HEADER_FOOTER_,
  // Armando 2026-09-10: /notifications entraba a MINIMAL por defecto y se perdian
  // header + aside + footer; entrando via el popup del user menu no habia como
  // regresar. Va con PROFILE (chrome completo) para que el usuario pueda navegar
  // a otras secciones desde el aside global. La duplicacion del sidebar para
  // usuarios multi-rol se arreglo en AsideMenuMain (FINAL_USER prioriza sobre
  // los demas roles).
  '/notifications': LAYOUT_CONFIGS.PROFILE,
  '/community': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/community/details/:id': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/community/new': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/community/edit/:id': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/community/success': LAYOUT_CONFIGS.HEADER_FOOTER_,
  '/my-expertise': LAYOUT_CONFIGS.PROFILE,
  // PR-I-85: pantalla member para publicar/editar su expertise (ExpertiseForm reusado).
  '/profile/edit-expertise': LAYOUT_CONFIGS.PROFILE,
  '/my-bookings': LAYOUT_CONFIGS.PROFILE,
  '/my-mastermind-circles': LAYOUT_CONFIGS.PROFILE,
  '/my-mastermind-circles/new': LAYOUT_CONFIGS.PROFILE,
  '/my-mastermind-circles/edit/:id': LAYOUT_CONFIGS.PROFILE,
  '/admin/community': LAYOUT_CONFIGS.PROFILE,
  '/admin/community/new': LAYOUT_CONFIGS.PROFILE,
  '/admin/community/review/:id': LAYOUT_CONFIGS.PROFILE,
  '/admin/banners': LAYOUT_CONFIGS.PROFILE,
  '/admin/payouts': LAYOUT_CONFIGS.PROFILE,
  '/admin/commissions': LAYOUT_CONFIGS.PROFILE,
  '/admin/audit-log': LAYOUT_CONFIGS.PROFILE,
  // Generic catalog admin screen (/admin/catalog/:slug). One pattern entry covers all catalogs so
  // the left menu (aside) renders; without it getLayoutConfig falls through to MINIMAL (no aside).
  '/admin/catalog/:slug': LAYOUT_CONFIGS.PROFILE,
  '/admin/catalog': LAYOUT_CONFIGS.PROFILE,
};

export const getLayoutConfig = (
  pathname: string,
  isAdmin: boolean
): LayoutConfig => {

  // Primero intentar match exacto
  if (ROUTE_LAYOUT_MAP[pathname]) {
    return ROUTE_LAYOUT_MAP[pathname]
  }

  // Luego intentar match dinámico
  for (const [route, config] of Object.entries(ROUTE_LAYOUT_MAP)) {
    const match = matchPath(pathname, {
      path: route,
      exact: true,
      strict: false,
    })

    if (match) {
      return config
    }
  }

  return LAYOUT_CONFIGS.MINIMAL
}

